import {gql} from "@apollo/client";

export const getBadIngredientsQuery = gql`
  query getBadIngredients($clientId: ID!) {
    badIngredients( clientId: $clientId) {
      id
      ingredient {id, name}
      details
    }
  }
`;

export const getClientIngredientsQuery = gql`
  query getClientIngredients {
    clientIngredients {
      id, name, details
    }
  }
`;

export const createBadIngredientMutation = gql`
  mutation createBadIngredient($ingredientId: ID!, $details: String, $clientId: ID!){
    createBadIngredient(
      input: {
        ingredientId: $ingredientId,
        details: $details,
        clientId: $clientId
      }) {
      badIngredient {
        id
      }
    }
  }
`

export const deleteBadIngredientMutation = gql`
  mutation deleteBadIngredient($id: ID!){
    deleteBadIngredient(
      input: {id: $id}) {
      badIngredient {
        id
      }
    }
  }
`
